export default __webpack_public_path__ + "static/media/1.45523a18.jpg";